@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.sourceDetailsWrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow:  hevo-toolkit-variables.$shadow-default;
  border-radius:  hevo-toolkit-variables.$border-radius-md;
  background:  hevo-toolkit-variables.$surface-bg;
}

.sourceDetailsContainer {
  display: flex;
  padding:  hevo-toolkit-variables.$spacer * 0.75;
  align-items: center;
  border-bottom: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
  flex-shrink: 0;
}

.sourceDetails {
  flex-grow: 1;
}

.schemaSearchContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0  hevo-toolkit-variables.$spacer * 1.25;
  min-height: 50px;
  border-bottom: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
  background-color:  hevo-toolkit-variables.$secondary-bg;
  flex-shrink: 0;
}

.listWrapper {
  flex: 1;
  overflow-y: auto;
}
